<template>
    <l-popup>
            <b-button 
                v-for="user in angebote" 
                :key="user.id" 
                :variant="user.suchStatus == 1 ? 'primary' : 'danger'" 
                block
                @click="$router.push({ path: '/nachrichten', query: { uid: user.id}})"
                class="d-flex flex-col justify-content-between"
                style="width:15em"
            >
                <b-badge class="align-self-center" :variant="user.lehrer ? 'warning' : 'info'">
                    <span v-if="user.lehrer">Lehrer</span>
                    <span v-else>Schüler</span>
                </b-badge>

                <div>
                    <div v-for="a in anfragen.filter(x => x.teilnehmer != null && x.teilnehmer.id == value.id)" :key="a.id">
                        <span v-if="a.teilnehmer.lastName">
                            {{ a.teilnehmer.firstName[0] }}. {{ a.teilnehmer.lastName }}
                        </span>
                        <span v-else>Nachrichten öffnen</span>
                    </div>
                    <span v-if="!anfragen || !anfragen.some(x => x.teilnehmer != null && x.teilnehmer.id == value.id)">
                        Nachricht senden
                    </span>
                </div>

                <img v-if="anfragen && !anfragen.some(a => a.teilnehmer != null && a.teilnehmer.id == user.id)"
                    :src="require('../assets/interface/edit.svg')" 
                    class="align-self-center" height="21em" width="21em" 
                    style="filter:invert(90%)" 
                />
                <img v-else
                    :src="require('../assets/interface/open.svg')" 
                    class="align-self-center" height="21em" width="21em" 
                    style="filter:invert(90%)" 
                />
            </b-button>
    </l-popup>
</template>

<script>
import { LPopup } from 'vue2-leaflet'
import { BBadge } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
export default {
    name: "UebersichtPopupUser",
    components: {
        LPopup,
        BBadge
    },
    computed: {
        ...mapGetters(['anfragen']),
        angebote: (that) => that.value ? that.value.angebote ? that.value.angebote : [that.value] : []
    },
    props: {
        value: undefined,
    }
}
</script>